export default {
  sessionInitialization: {
    OIDC_AUTH: 'Lade Nutzer:innendaten',
    STEERING_INITIALIZATION: 'Initialisiere Inhaltsverwaltung',
  },

  loginScreen: {
    intro:
      'AURA ist Radioautomationssuite die speziell auf die Bedürfnisse von Freien Radios zugeschnitten ist. AURA wurde in der Gemeinschaft mehrerer österreichischer Community-Radios entwickelt und ist quelloffen.',
  },

  programEntry: {
    scheduled: 'Dieser Programplatz wurde regulär geplant.',
    fallback:
      'Dieser Programmplatz war frei und wurde automatisch durch das Rückfallprogramm des Radios ersetzt.',
    startsAt: 'Beginn am %{formattedDate}',
    endsAt: 'Endet am %{formattedDate}',
  },

  showManager: {
    title: 'Sendereihen',
    generalSettings: 'Allgemeine Einstellungen der Sendereihe',
  },

  myShows: {
    title: 'Meine Sendereihen',
    itemsPerPage: 'Sendereihen pro Seite',
    searchLabel: 'Suche nach Namen',
    searchPlaceholder: 'Name der Sendereihe...',
    categoryLabel: 'Suche nach Kategorie',
    showCount: 'Zeige %{count} von %{total} Sendereihen.',
    sortAndFilter: 'Sortieren und Filtern der Sendereihen',
    sortAndFilterShows: 'Sortieren und Filtern',
    sort: 'Sortieren',
    filter: 'Filtern',
  },

  showListGrid: {
    otherShows: 'Weitere Sendereihen',
  },

  profile: {
    singular: 'Profil',
    plural: 'Profile',
    fields: {
      name: 'Name',
      email: 'E-Mail',
      biography: 'Biographie',
      image: 'Bild',
      links: 'Links',
      isActive: 'Aktiv',
      ownerIds: 'Zugewiesene Nutzer:innenkonten',
    },
    labels: {
      hasAccount: 'Hat Konto',
      createNew: '„%{name}“ anlegen',
      similarSelected: 'Ähnliche bereits ausgewählte Profile: %{names}',
      hostsOnly: 'Nur Redakteur:innen',
      editorOfShows: 'Redakteur:in der Sendereihen',
      notAssignedAsEditor: 'Dieses Profil ist keiner Sendereihe als Redakteur:in zugewiesen.',
    },
    creator: {
      title: 'Neues Profil anlegen',
      save: 'Profil anlegen',
    },
    editor: {
      deletion: {
        label: 'Profil löschen',
        description:
          'Entfernt das Profil und alle bestehenden Verknüpfungen zu Sendereihen und Episoden.',
        confirm: {
          text: 'Das Profil wird <strong>unwiederbringlich gelöscht</strong>. Eine spätere Wiederherstellung ist nicht möglich. Bestehende Verknüpfungen zu Sendereihen und Episoden werden ebenfalls entfernt. Bist du sicher, dass du das Profil <strong>%{profile}</strong> löschen willst?',
          confirmLabel: 'Lösche Profil',
        },
      },
    },
  },

  labels: {
    noneAssigned: 'Keine zugewiesen',
    missing: 'Fehlt',
    duration: 'Dauer',
    search: 'Suche',
    minutes: '1 Minute |||| %{smart_count} Minuten',
    minutesShort: '1 min |||| %{smart_count} min',
  },

  episode: {
    singular: 'Sendung',
    plural: 'Sendungen',
    fields: {
      title: 'Titel',
      timeslotIds: 'Sendetermine',
      mediaDescription: 'Medienbeschreibung',
    },
    labels: {
      changingPastMedia:
        'Diese Sendung wurde bereits ausgestrahlt. Bitte sei achtsam bei der Änderung von Medienquellen.',
      assign: 'Andere Sendung zuweisen',
      noneAssigned: 'Es wurden bisher keine Sendungen zugewiesen.',
      noneFound: 'Es wurden keine Sendungen gefunden.',
      noTitle: '(kein Titel gesetzt)',
      createNew: 'Neue Sendung anlegen',
      perPage: 'Sendungen pro Seite',
      onDate: 'Sendung am %{date} Uhr',
      numbered: 'Sendung #%{number}',
      noAdditionalBroadcasts: 'Keine weiteren Sendetermine geplant',
      additionalBroadcasts: 'Weitere Sendetermine',
      searchPlaceholder: 'z.B. Sendungsinhalte wie Titel',
      withoutTimeslots: 'Ohne Sendetermine',
      beforeDate: 'Vor dem',
    },
    deletion: {
      title: 'Sendung löschen',
      description: 'Bist du sicher, dass du diese Sendung löschen willst?',
      confirmLabel: 'Ja, Sendung löschen',
    },
    assignment: {
      clear: 'Zuweisung aufheben',
      clearDescription:
        'Entferne die Zuweisung, wenn du die Sendung lieber an einem anderen Sendetermin spielen willst. Der Inhalt der Sendung wird nicht gelöscht.',
      searchExisting: 'Bestehende Sendungen durchsuchen',
    },
  },

  timeslot: {
    singular: 'Sendetermin',
    plural: 'Sendetermine',
    count: 'einen Sendetermin |||| %{smart_count} Sendetermine',
    fields: {
      start: 'Beginn',
    },
    labels: {
      noneAssigned: 'Es wurden bisher keine Sendetermine zugewiesen.',
      noneFound: 'Es wurden keine Sendetermine gefunden.',
      since: 'Ab',
      inFuture: 'Zukünftige',
      inPast: 'Vergangene',
      perPage: 'Termine pro Seite',
      duration: 'Länge',
      loading: 'Termine werden geladen',
      isRepetition: 'Dieser Sendetermin ist eine Wiederholung einer vergangenen Sendung.',
      broadcastTime: 'Sendezeit',
      showActions: 'Aktionen öffnen',
      showInWeekCalendar: 'Im Wochenkalender anzeigen',
      mediaSources: 'Medienquellen dieses Sendetermins',
      originallyPlannedOn: 'Ursprünglich am %{date}',
      editTime: 'Sendezeit bearbeiten',
      inheritedMedia: 'Derzeitige Medienquellen',
      repetitionOf: 'Wiederholung vom %{date}',
    },
    flows: {
      assignEpisode: {
        title: 'Sendung zuweisen',
        action: 'Zuweisen',
      },
      delete: {
        title: 'Sendetermin löschen',
        action: 'Sendetermin löschen',
        message: 'Bist du sicher, dass du diesen Sendetermin löschen willst?',
        changingPast:
          'Der Sendetermin hat bereits begonnen oder liegt in der Vergangenheit. Bitte stelle sicher, dass dieser wirklich gelöscht werden soll.',
      },
      move: {
        title: 'Sendezeit',
        action: 'Neue Sendezeit speichern',
        newStart: 'Neue Startzeit',
        newEnd: 'Neue Endzeit',
        duration: 'Dauer',
        changeDuration: 'Dauer anpassen',
        changingPast:
          'Deine Eingaben verändern das vergangene oder laufende Programm. Bitte stelle sicher, dass diese korrekt sind.',
        conflictResolution: {
          title: 'Konflikte mit anderen Sendeterminen',
          message: 'Bei der Verschiebung des Sendetermins treten Konflikte auf.',
          deleteConflicts: 'Konflikte löschen',
        },
        errors: {
          mustBeInFuture: 'Das Datum muss in der Zukunft liegen.',
          hasConflicts:
            'Zu diesem Zeitpunkt ist bereits ein anderer Sendetermin eingeplant. Du kannst trotzdem fortfahren und die Konflikte beheben.',
          cannotSolveConflicts: 'Es gibt keine Lösung für die Konflikte.',
        },
      },
    },
  },

  media: {
    singular: 'Medien',
    plural: 'Medien',
    duration: 'Länge',
    editor: {
      title: 'Medienquellen',
      isSaving: 'Medienquellen werden gespeichert',
      editMediaSource: 'Medienquelle bearbeiten',
      deleteMediaSource: 'Medienquelle löschen',
      noEntries: 'Es wurden keine Medienquellen zugewiesen.',
      entriesAdd: {
        retry: 'Erneut versuchen',
        discard: 'Verwerfen',
        error: 'Einige Einträge konnten nicht hinzugefügt werden.',
      },
      upload: {
        pending: 'Neue Quellen',
        step: {
          fetching: 'Importiere',
          normalizing: 'Normalisiere',
          unknown: 'Verarbeite',
        },
      },
      uploadFiles: {
        discarded:
          '<p>Einige Dateien wurden aussortiert, weil sie nicht als Audiodateien erkannt wurden. Dazu gehören:</p>%{discardedFileList}',
      },
      control: {
        _or: '- oder -',
        dropFiles: 'Ziehe Dateien auf diese Fläche',
        selectFiles: 'Lokale Datei auswählen',
        importFile: 'Datei von URL importieren',
        addStream: 'Stream hinzufügen',
        addInput: 'Eingang hinzufügen',
        addM3u: 'M3U hinzufügen',
      },
      importFileDialog: {
        title: 'Datei von URL importieren',
        saveLabel: 'Datei hinzufügen',
      },
      addInputDialog: {
        title: 'Eingang als Medienquelle hinzufügen',
        saveLabel: 'Eingang hinzufügen',
      },
      addStreamDialog: {
        title: 'Stream als Medienquelle hinzufügen',
        saveLabel: 'Stream hinzufügen',
      },
      addM3uDialog: {
        title: 'M3U als Medienquelle hinzufügen',
        saveLabel: 'M3U hinzufügen',
      },
    },
    labels: {
      variableDuration: 'Dynamische Länge',
      loading: 'Medien werden geladen',
    },
    inheritance: {
      schedule: ' von Sendeschema übernommen',
      show: 'von Sendereihe übernommen',
    },
    state: {
      invalid: {
        tooShort: {
          title: 'Es ist Sendezeit übrig',
          shortLabel: 'Zu kurz',
          description: `Die hinterlegten Medienquellen sind um <strong>%{offset}</strong> kürzer als die Dauer des Sendetermins. Bitte füge weitere Medienquellen hinzu.`,
        },
        tooLong: {
          title: 'Die Sendezeit ist überschritten',
          shortLabel: 'Zu lang',
          description: `Die hinterlegten Medienquellen sind um <strong>%{offset}</strong> länger als die Dauer des Sendetermins. Bitte kürze den Sendungsinhalt, damit die Sendung nicht unterbrochen wird.`,
        },
        multipleUnknownDurations: {
          title: 'Medienquellen mit ungültiger Länge',
          shortLabel: 'Ungültige Medienquellen',
          description: `Es darf maximal eine Medienquelle ohne Länge geben. Bitte setze für die betreffenden Medienquellen eine Länge.`,
        },
        missing: {
          title: 'Keine Medienquellen',
          shortLabel: 'Keine Medienquellen',
          description: 'Es gibt keinerlei Medienquellen für die Ausspielung im Radio.',
        },
      },
    },
  },

  mediaSource: {
    singular: 'Medienquelle',
    plural: 'Medienquellen',
    count: '%{smart_count} Medienquelle |||| %{smart_count} Medienquellen',
    fields: {
      source: 'Quelle',
    },
    labels: {
      noneAssigned: 'Es wurden bisher keine Medienquellen zugewiesen.',
      autoDuration: 'Automatisch berechnete Länge',
    },
    type: {
      file: 'Upload',
      stream: 'Stream',
      m3u: 'M3U',
      line: 'Eingang',
      unknown: 'Unbekannt',
    },
  },

  category: {
    singular: 'Kategorie',
    plural: 'Kategorien',
  },

  program: {
    singular: 'Programm',
    labels: {
      actions: 'Aktionen',
    },
    filter: {
      open: 'Anzeigeoptionen öffnen',
      sections: {
        filter: {
          title: 'Anzeigen',
          values: {
            none: 'Alles',
            own: 'Meine Sendereihen',
            free: 'Freie Sendetermine',
            invalidMedia: 'Fehlerhafte Medienquellen',
            emptyEpisode: 'Leere Sendung',
          },
        },
      },
    },
    flows: {
      prolong: {
        title: 'Automatische Programmverlängerung',
        action: 'Programm bis %{until} verlängern',
        description:
          'Die Programmverlängerung wird im Hintergrund ausgeführt. Es kann also eine Weile dauern, bis der Prozess abgeschlossen ist.',
      },
    },
  },

  show: {
    singular: 'Sendereihe',
    plural: 'Sendereihen',
    fields: {
      categoryIds: 'Kategorien',
      cbaSeriesId: 'CBA ID',
      description: 'Beschreibung',
      email: 'E-Mail',
      fundingCategoryId: 'Förderkategorie (z.B. für RTR)',
      hostIds: 'Redaktion',
      id: 'ID',
      imageId: 'Bild',
      internalNote: 'Interne Notiz',
      involvedPeopleCount: 'Anzahl beteiligter Personen',
      storageQuota: 'Speicherplatz (MiB)',
      usedMediaQuota: 'Verbrauchter Speicherplatz',
      isActive: 'Aktiv',
      isOwner: 'Verwaltet von mir',
      languageIds: 'Sprachen',
      links: 'Links',
      logoId: 'Logo',
      musicFocusIds: 'Musikgenres',
      name: 'Titel',
      ownerIds: 'Administrator:innen',
      predecessorId: 'Vorgänger',
      shortDescription: 'Untertitel / Kurzbeschreibung',
      slug: 'Kürzel',
      topicIds: 'Themen',
      typeId: 'Art der Sendereihe',
      updatedAt: 'Letzte Aktualisierung',
      updatedBy: 'Aktualisiert von',
    },
    labels: {
      loading: 'Lade Sendereihen',
      onAir: 'Auf Sendung',
      onAirSince: 'Seit %{from}.',
      onAirBetween: 'Von %{from} bis %{to}.',
      onAirNone: 'War bisher nicht auf Sendung.',
    },
    flags: {
      stationFallback: {
        label: 'Ausweichprogramm',
        description:
          'Das Programm dieser Sendereihe wird gespielt, wenn kein anderes Programm in einem Zeitraum zugewiesen ist.',
      },
    },
    slugDetail: {
      title: 'URL-Kürzel',
      editRemark:
        'Das URL-Kürzel kann in der <a href="#%{dangerZoneId}">%{dangerZone}</a> bearbeitet werden.',
    },
    housekeeping: {
      flows: {
        archival: 'Archivierung',
        deletion: 'Löschung',
        slugRenaming: 'Umbenennung des URL-Kürzel',
      },
    },
    section: {
      basic: { title: 'Allgemeine Angaben' },
      content: { title: 'Inhaltliche Angaben' },
      contact: { title: 'Redaktion & Kontakt' },
      administrative: { title: 'Verwaltung' },
      media: { title: 'Standardmedienquellen' },
    },
    editor: {
      deactivation: {
        label: 'Sendereihe deaktivieren',
        description:
          'Archiviert die Sendereihe und entfernt alle für die Zukunft geplanten Sendetermine.',
        confirm: {
          text:
            'Alle für die Zukunft geplanten <strong>Sendetermine</strong> und zugeordnete Informationen <strong>werden entfernt</strong>. ' +
            'Bist du sicher, dass du <strong>%{show}</strong> deaktivieren willst?',
          prompt: 'Bitte gib <code>%{challenge}</code> als Bestätigung ein.',
          confirmLabel: 'Deaktiviere Sendereihe',
        },
      },
      activation: {
        label: 'Sendereihe aktivieren',
        description: 'Dearchiviert die Sendereihe. Sendeschemata müssen neu angelegt werden.',
      },
      deletion: {
        label: 'Sendereihe löschen',
        description:
          'Entfernt die Sendereihe und alle zu ihr hinterlegten Daten inkl. Sendeschema, Sendetermine und Sendungen.',
        confirm: {
          text: 'Alle Informationen zu dieser Sendereihe werden <strong>unwiederbringlich gelöscht</strong>. Eine spätere Wiederherstellung ist nicht möglich. Bist du sicher, dass du <strong>%{show}</strong> löschen willst?',
          prompt: 'Bitte gib <code>%{challenge}</code> als Bestätigung ein.',
          confirmLabel: 'Lösche Sendereihe',
        },
      },
      slugRenaming: {
        dialogTitle: 'Umbenennung des URL-Kürzels',
        label: 'Umbenennen',
        description:
          'Benennt das URL-Kürzel der Sendereihe um. Dieses Kürzel wird wahrscheinlich in Links auf Websites benutzt. Bestehende Verweise auf die Sendereihe könnten nach einer Änderung ungültig sein und sollten gut abgewägt sein.',
        confirm: {
          text: 'Das URL-Kürzel wird umbenannt. Bestehende Links auf die Sendereihe werden anschließend eventuell ins Leere führen. Bist du sicher, dass du das URL-Kürzel für <strong>%{show}</strong> ändern willst?',
          prompt: 'Bitte gib <code>%{challenge}</code> als Bestätigung ein.',
          confirmLabel: 'Ändere URL-Kürzel der Sendereihe',
        },
      },
    },
  },

  showFilter: {
    order: {
      choices: {
        id: { name: 'ID', directions: { asc: '0 - 9', desc: '9 - 0' } },
        name: { name: 'Name', directions: { asc: 'A - Z', desc: 'Z - A' } },
        is_active: { name: 'Aktiv', directions: { asc: 'Aktive zuletzt', desc: 'Aktive zuerst' } },
        is_owner: {
          name: 'Verwaltet von mir',
          directions: { asc: 'Eigene zuletzt', desc: 'Eigene zuerst' },
        },
        updated_at: {
          name: 'Letzte Aktualisierung',
          directions: { asc: 'Älteste zuerst', desc: 'Neueste zuerst' },
        },
        updated_by: { name: 'Aktualisiert von', directions: { asc: 'A - Z', desc: 'Z - A' } },
      },
    },
  },

  credits: {
    title: 'Credits',
    intro: 'AURA wird unter der GNU Affero General Public License v3 entwickelt.',
    contributors: 'Beitragende',
    contributorLabel: 'Aktive und vergangene Entwickler sind:',
    moreInfo:
      'Mehr Informationen gibt es im <a href="https://gitlab.servus.at/aura/dashboard">Dashboard-Repository</a>.<br>Um eine Gesamtübersicht über AURA zu erhalten, besuche <a href="https://aura.radio">aura.radio</a>.<br>Alle AURA-Repositories können auf <a href="https://code.aura.radio">https://code.aura.radio</a> eingesehen werden.',
  },

  generalDocumentation: 'Hilfe & Dokumentation',

  // Layout
  loadMoreItems: 'Mehr %{items} laden',
  loadingData: 'Lade %{items}',
  loading: 'Lädt..',
  cancel: 'Abbrechen',
  dismiss: 'Verwerfen',
  back: 'Zurück',
  moreOptions: 'Weitere Optionen',
  yes: 'Ja',
  no: 'Nein',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  help: 'Hilfe',
  delete: 'Löschen',
  unassign: 'Abwählen',
  unassignItem: '%{item} abwählen',
  add: 'Hinzufügen',
  save: 'Speichern',
  goBack: 'Zur vorherigen Seite zurückkehren',
  ok: 'OK',
  browse: 'Auswählen',
  drop: 'Datei hier ablegen',
  edit: 'Bearbeiten',
  move: 'Verschieben',
  language: 'Sprache',
  slug: 'Slug',
  dangerZone: 'Gefahrenzone',
  unimplemented: 'Potzblitz!\n\nDieses Feature ist noch nicht implementiert!',
  noneSetMasculine: '(keiner gesetzt)',
  noneSetFeminine: '(keine gesetzt)',
  noneSetNeuter: '(keines gesetzt)',
  noAssignedShows:
    'Dir sind noch keine Sendereihen zugewiesen.<br>Diese können im <a href="%{adminUrl}">Administrationsbereich</a> zugewiesen werden.',
  by: 'von',
  actionRequired: 'Aktion erforderlich',

  auth: {
    signOut: 'Abmelden',
    signIn: 'Anmelden',
    permissionError: 'Du bist nicht berechtigt diese Seite zu sehen',
  },

  drag: {
    up: 'Nach oben verschieben',
    down: 'Nach unten verschieben',
    move: 'Verschieben',
  },

  construction: {
    label: 'Baustelle',
  },

  topNavigation: {
    title: 'Obere Navigation',
  },

  navigation: {
    _title: 'Hauptnavigation',
    _open: 'Öffne Hauptnavigation',
    _close: 'Schließe Hauptnavigation',
    _jumpToContent: 'Zum Inhalt springen',
    home: 'Home',
    shows: 'Sendereihen',
    show: {
      episodes: 'Sendungen',
      timeslots: 'Sendetermine',
      schedules: 'Sendeschemata',
      settings: 'Einstellungen',
    },
    episode: {
      _title: 'Sendung am %{start}',
      details: 'Beschreibung',
    },
    overviews: 'Übersichten',
    program: 'Programm',
    misc: 'Sonstiges',
    profiles: 'Profile',
    calendarWeek: 'Wochenkalender',
    calendarDay: 'Tageskalender',
    programProlongation: 'Verlängerung',
    settings: 'Einstellungen',
    profile: 'Profil',
    administration: 'Administration',
    help: 'Hilfe',
  },

  breadcrumbs: {
    _title: 'Brotkrümel',
  },

  profileList: {
    title: 'Profile',
    searchLabel: 'Suche nach Namen',
    searchPlaceholder: 'Name des Profils...',
  },

  profileDetails: {
    assignedAccounts: 'Zugewiesene Konten',
    data: 'Daten',
  },

  myAccount: {
    data: 'Mein Konto',
    profiles: 'Meine Profile',
    aboutMe: 'Über mich',
    settings: 'Einstellungen',
  },

  settings: {
    language: {
      label: 'Sprache',
      description: 'Diese Einstellung wird in deinem Browser gespeichert.',
    },
    darkMode: {
      label: 'Dunkelmodus',
      description:
        'Zeigt die Seite im Dunkelmodus an. Der Dunkelmodus ist noch im experimentellen Zustand. Manche Komponenten sind noch nicht angepasst, andere brauchen zum Teil noch etwas Feinschliff.',
    },
  },

  userMenu: {
    myAccount: 'Mein Konto',
    logout: 'Abmelden',
  },

  footer: {
    navigationTitle: 'Hilfe & Weiteres',
    tagline: 'Alles was Du für ein Freies Radio brauchst',
  },

  // Specific components
  header: {
    showMoreDesktop: 'Klicke den Menü-Knopf für mehr',
    showMoreMobile: 'Für mehr Optionen, klicke auf den Menü-Knopf rechts',
  },

  input: {
    singular: 'Eingang',
    unknown: 'Unbekannter Eingang',
  },

  file: {
    url: 'URL',
    name: 'Dateiname',
    unnamed: 'Unbenannte Datei',
    duration: 'Länge',
    durationUnknown: 'Dynamische Länge',
    durationPlaceholder: 'z.B. 2m6s',
    uploadProgress: 'Fortschritt des Dateiuploads',
    uploadError: 'Fehler beim Upload',
    retryUpload: 'Upload erneut versuchen',
    metadata: {
      _title: 'Metadaten',
      album: 'Album',
      artist: 'Künstler:in',
      title: 'Titel',
      fromAlbum: '<em>%{title}</em> vom Album <em>%{album}</em>.',
      byArtist: '<em>%{title}</em> von <em>%{artist}</em>.',
      byArtistFromAlbum:
        '<em>%{title}</em> von <em>%{artist}</em> aus dem Album <em>%{album}</em>.',
    },
    importLog: {
      title: 'Dateiimportprotokoll',
      showImportLog: 'Zeige Importprotokoll',
      start: '# %{title} beginnt am %{time}',
    },
  },

  mediaSourceJob: {
    showInfo: 'Details anzeigen',
    state: {
      label: {
        queued: 'Eingereiht',
        processing: 'Verarbeite',
        resolvingMedia: 'Löse Medien auf',
        creatingBatteryPipeline: 'Erstelle Pipeline',
        // battery
        upload: 'Hochladen',
        resolvingCBA: 'Prüfe CBA',
        importingFile: 'Importiere',
        checkingData: 'Prüfe Daten',
        extractingAudio: 'Extrahiere Audio',
        extractingMetadata: 'Extrahiere Metadaten',
        normalizingFile: 'Normalisiere',
        convertingFile: 'Konvertiere',
        generatingMetadata: 'Generiere Metadaten',
        storeInFilesystem: 'Lege Datei ab',
        storeInDatabase: 'Speichere',
        syncing: 'Synchronisiere',
      },
      failures: {
        failed:
          'Bei der Verarbeitung der Medienquelle trat ein Fehler auf. Das kann ein temporäres Problem sein.',
        cancelled:
          'Du hast den Vorgang abgebrochen. Du kannst es erneut probieren, falls das ein Fehler war.',
        rejected: 'Die Medienquelle konnte nicht verarbeitet werden.',
        notAnAudioFile: 'Die ausgewählte Datei enthält keine Audiodaten.',
        uploadFailed: 'Der Upload der Datei ist fehlgeschlagen.',
        unableToCreateMediaSource: 'Die Medienquelle konnte nicht erstellt werden.',
        unableToResolveMedia: 'Medien konnten nicht aufgelöst werden.',
        unableToCreatePipeline: 'Import Pipeline konnte nicht erstellt werden.',
      },
    },
  },

  mediaTable: {
    // Our translation framework automatically picks singular/plural
    items: '%{smart_count} Eintrag |||| %{smart_count} Einträge',
    assign: 'Zuweisen',
    unset: 'Zuweisung aufheben',

    index: 'Nr',
    description: 'Beschreibung',
    entries: 'Einträge',
    duration: 'Länge',
    lastEdit: 'Bearbeitet am',
    type: 'Typ',
    source: 'Quelle',
    actions: 'Aktionen',
  },

  linkType: {
    inactive: 'Veraltet',
  },

  link: {
    urlExample: 'z.B. https://aura.radio',
    noneSet: 'Es wurden keine Links zugewiesen.',
    fields: {
      typeId: 'Linktyp',
      url: 'Web Adresse',
    },
  },

  showSelector: {
    keyboardShortcut: 'Alt + K',
    selectShowMany: 'Sendereihe wählen',
    selectShow: 'Sendereihe auswählen',
    noData: 'Es wurden bisher keine Sendereihen angelegt.',
    noDataMatch: 'Es gibt keine Sendereihen, die deinen Suchkriterien entsprechen.',
    showState: {
      label: 'Status der Sendereihe',
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
  },

  showSchedules: {
    title: 'Sendeschemata',
    times: 'Sendezeiten',
    rhythm: 'Rhythmus',
    firstBroadcast: 'Startdatum',
    lastBroadcast: 'Enddatum',
    noSchedulesAvailable: 'Für die aktuelle Auswahl liegen keine Sendeschemata vor.',
    showAll: 'Alles anzeigen',
    hide: 'Ausblenden',
    scheduleDescription:
      '%{rhythm} ab %{startDate} jeweils von %{startTime} Uhr bis %{endTime} Uhr.',
    scheduleDescriptionFinite:
      '%{rhythm} ab %{startDate} bis zum %{endDate} jeweils von %{startTime} Uhr bis %{endTime} Uhr.',
    selection: {
      all: 'Alle',
      relevant: 'Aktuelle',
    },
  },

  languageSelector: {
    label: 'Wähle eine Sprache',
  },

  user: {
    fields: {
      username: 'Benutzername',
      firstName: 'Vorname',
      lastName: 'Nachname',
      name: 'Name',
      email: 'E-Mail',
      profile: {
        cbaUsername: 'Kontoname',
        cbaUserToken: 'Token',
      },
    },
    labels: {
      noProfilesAssigned: 'Deinem Konto sind bisher keine Profile zugewiesen.',
    },
  },

  noteEditor: {
    _title: 'Sendungsbeschreibung',
    title: 'Titel',
    titlePlaceholder: 'Gib einen Titel ein',
    summary: 'Zusammenfassung',
    summaryPlaceholder: 'Gib eine Zusammenfassung ein',
    content: 'Inhalt',
    contentPlaceholder: 'Beschreibe den Inhalt der Sendung',
    image: 'Bild',
    tags: 'Schlagwörter',
    contributors: 'Mitwirkende',
    languages: 'Sprachen',
    topics: 'Themen',
    links: 'Links',
    cbaId: 'CBA Id',
  },

  error: {
    server: {
      'multiple-null-duration-media-sources':
        'Es darf nicht mehr als eine Medienquelle ohne festgelegte Länge geben. Bitte setze für die bestehenden Medienquellen eine Länge.',
      'no-fallback-show-defined':
        'In den Einstellungen des Radios wurde keine Fallback-Show definiert. Diese muss für eine korrekte Darstellung des Kalenders gesetzt werden.',
      'no-start-after-end': 'Das Startdatum muss vor dem Enddatum liegen.',
      'no-same-day-start-and-end':
        'Startdatum und Enddatum dürfen nicht auf den selben Tag fallen.',
      'first-date-does-not-correspond-to-rrule-by-weekdays':
        'Der erste Tag des Sendeschemas lässt sich nicht mit der angegebenen Wiederholungsregel in Einklang bringen.',
      incorrect_type:
        'Der Server hat einen anderen Wert erwartet. Bitte melde diesen Fehler an das Entwicklungsteam.',
      does_not_exist: 'Der Eintrag existiert nicht.',
      max_length: 'Der Wert dieses Felds ist zu lang.',
      min_length: 'Der Wert dieses Felds ist zu kurz.',
      unknown: 'Ein unbekannter Fehler ist aufgetreten.',
      exception: 'Ein unbekannter Serverfehler ist aufgetreten.',
      permission_denied: 'Du hast nicht genügend Berechtigungen.',
      required: 'Dieses Feld muss ausgefüllt werden.',
      invalid: 'Der Wert dieses Felds ist ungültig.',
      null: 'Dieses Feld darf nicht leer sein.',
      blank: 'Dieses Feld darf nicht leer sein.',
      unique: 'Der Wert dieses Felds muss einzigartig sein.',
      connection:
        'Es gibt ein Problem bei der Verbindung mit dem Server. ' +
        'Dies kann durch eine temporäre Unterbrechung deiner Internetverbindung oder ein Problem des Servers ausgelöst werden.',
      login:
        'Die Anmeldung ist aus einem unbekannten Grund fehlgeschlagen. Bitte wende dich an eine:n Administrator:in.',
      failed_integrity_checks:
        'Der Server hat einen Fehler bei der Datenverarbeitung festgestellt. Bitte wende dich an eine:n Administrator:in.',
      recording_not_available:
        'Die Sendungsaufnahme wird am gewählten Zeitpunkt nicht verfügbar sein.',
    },
    oidc: {
      crypto_unavailable_browser:
        'Dein Browser ist zu alt und unterstützt eine wichtige kryptografische Funktion nicht. Du wirst dich nicht einloggen können.',
      crypto_unavailable_origin:
        'Die aktuelle Umgebung des Dashboards verhindert die Nutzung einer wichtigen kryptografischen Funktion. Bitte benutze HTTPS oder konfiguriere diese Origin in deinen Browsereinstellungen als sicher. Du wirst dich nicht einloggen können.',
      invalid_request:
        'Der Server unterstützt das Anmeldeverfahren nicht. Bitte lasse eine:n Administrator:in prüfen, ob der Authorization Code Flow für den OIDC Client des Dashboard aktiviert ist.',
    },
  },

  imagePicker: {
    title: 'Suche ein Bild aus',
    browseImages: 'Bilder durchstöbern',
    editCurrentImage: 'Aktuelles Bild bearbeiten',
    saveChanges: 'Änderungen speichern',
    useImage: 'Dieses Bild wählen',
    chooseAnImage: 'Bild auswählen',
    uploadImage: 'Neues Bild hochladen',
    abort: 'Abbrechen',
    reset: 'Bild zurücksetzen',
    error: {
      default: 'Das Bild konnte nicht hochgeladen werden.',
      tooLarge: 'Die Dateigröße des Bilds, das von dir ausgewählt wurde, ist zu groß.',
    },
    liability: {
      title: 'Rechtliches',
      confirm: 'Ich habe die Rechte/ Lizenz für die Veröffentlichung dieses Bildes abgeklärt.',
      description: 'Unrechtmäßig verwendete Bilder können hohe Kosten für dein Radio verursachen.',
    },
  },

  licensing: {
    singular: 'Lizenzierung',
    fields: {
      license: 'Lizenz',
      credits: 'Urheber:in',
      isUseExplicitlyGrantedByAuthor: 'Urheber:in erlaubt Veröffentlichung',
    },
  },

  imageManipulation: {
    processingImage: 'Das Bild wird geladen.',
    rotateLeft: 'Drehe das Bild 90° entgegen des Uhrzeigersinns.',
    rotateRight: 'Drehe das Bild 90° im Uhrzeigersinn.',
    flipHorizontal: 'Spiegel das Bild um die vertikale Achse.',
    flipVertical: 'Spiegel das Bild um die horizontale Achse.',
    crop: 'Schneide das Bild auf den Auswahlbereich zu.',
    cropActivate: 'Aktiviere den Zuschnittmodus.',
    cropUnfinishedError:
      'Drücke den Button, um den aktuell gewählten Bildausschnitt zu bestätigen.',
    aspectRatioError:
      'Das Bild wurde nicht auf das erforderliche Seitenverhältnis zugeschnitten. Drücke den Button, um den aktuell gewählten Bildausschnitt zu bestätigen.',
  },

  image: {
    altText: 'Alternativtext (für Screenreader)',
  },

  license: {
    moreAbout: 'Mehr zu dieser Lizenz...',
    helpMeChoose: 'Hilf mir, eine Lizenz auszuwählen…',
    validation: {
      requiresExpressPermissionForPublication:
        'Die Lizenz erfordert eine explizite Zustimmung zur Veröffentlichung seitens des:der Urheber:in.',
      requiresCredits:
        'Die Lizenz erfordert die Nennung des:der Urheber:in. Bitte gib deren Namen an.',
    },
  },

  saveIndicator: {
    label: {
      pending: 'Wird gespeichert',
      success: 'Wurde gespeichert',
      failure: 'Fehler beim Speichern',
    },
  },

  showCreator: {
    title: 'Neue Sendereihe anlegen',
    missingShowTypes:
      'Es wurden noch keine Arten von Sendereihen angelegt. Du kannst das im <a href="%{adminUrl}/program/type/add/" target="_blank">Administrationsbereich</a> nachholen.',
    missingShowFundingCategories:
      'Es wurden noch keine Förderkategorien angelegt. Du kannst das im <a href="%{adminUrl}/program/fundingcategory/add/" target="_blank">Administrationsbereich</a> nachholen.',
  },

  conflictResolution: {
    title: 'Konfliktbehebung für neues Programm',

    conflictingSlot: 'Neuer Sendetermin',
    projectedSlot:
      'Der neue Sendetermin am <b class="tw-font-medium">%{firstDate}</b> von <b class="tw-font-medium">%{startTime}</b> bis <b class="tw-font-medium">%{endTime}</b> steht mit einem Termin aus dem folgenden Sendeschema in Konflikt:',

    alreadyResolved:
      'Du hast bereits einen Konflikt behoben. |||| Du hast bereits %{smart_count} Konflikte behoben.',
    leftToResolve: 'Noch einen Konflikt zu beheben |||| Noch %{smart_count} Konflikte zu beheben',
    noneLeftToResolve: 'Du hast alle Konflikte behoben!',
    applySolution: 'Konfliktlösungen anwenden',
    conflictOf: 'Konflikt %{number} von %{total}',

    gotoPrevious: 'Zum vorherigen Konflikt springen',
    gotoNext: 'Zum nächsten Konflikt springen',
    gotoNextUnresolved: 'Nächster ungelöster Konflikt',

    abort: 'Bist du sicher, dass du die Konfliktlösung abbrechen willst?',
    abortConfirm: 'Ja, Konfliktlösung abbrechen',
    abortCancel: 'Nein, weitermachen',
    abortTitle: 'Konfliktlösung abbrechen',

    applySolutionForSchedule:
      'Lösung dieses Konflikts für alle Konflikte mit diesem Sendeschema anwenden',
    appliedSolutionForSchedule:
      'Lösung dieses Konflikts wird für alle Konflikte mit diesem Sendeschema angewendet',

    whichStrategy: 'Wie soll der Konflikt behoben werden?',
    strategies: {
      theirs: {
        label: 'Neuen Sendetermin löschen und bestehenden behalten',
        description: '',
      },
      'theirs-start': {
        label: 'Neuen Sendetermin kürzen und <b>nach</b> bestehendem Sendetermin einfügen',
        description:
          'Am Anfang des neuen Sendetermins wird gekürzt und die Endzeit des bestehenden Sendetermins wird somit zur Startzeit des neuen Sendetermins.',
      },
      'theirs-end': {
        label: 'Neuen Sendetermin kürzen und <b>vor</b> bestehendem Sendetermin einfügen',
        description:
          'Am Ende des neuen Sendetermins wird gekürzt und die Startzeit des bestehenden Sendetermins wird somit zur Endzeit des neuen Sendetermins.',
      },
      'theirs-both': {
        label: 'Neuen Sendetermin auftrennen und bestehenden dazwischenschieben',
        description:
          'Der neue Sendetermin wird in zwei Teile aufgeteilt. Der erste Teil endet mit der Startzeit und der zweite Teil beginnt mit der Endzeit des existierenden Sendetermins.',
      },
      ours: {
        label: 'Neuen Sendetermin behalten und bestehenden löschen',
        description: '',
      },
      'ours-start': {
        label: 'Bestehenden Sendetermin kürzen und <b>vor</b> neuem Sendetermin einfügen',
        description:
          'Am Ende des bestehenden Sendetermins wird gekürzt und die Startzeit des neuen Sendetermins wird somit zur Endzeit des bestehenden Sendetermins.',
      },
      'ours-end': {
        label: 'Bestehenden Sendetermin kürzen und <b>nach</b> neuem Sendetermin einfügen',
        description:
          'Am Anfang des bestehenden Sendetermins wird gekürzt und die Endzeit des neuen Sendetermins wird somit zur Startzeit des bestehenden Sendetermins.',
      },
      'ours-both': {
        label: 'Bestehenden Sendetermin auftrennen und neuen dazwischenschieben',
        description:
          'Der bestehende Sendetermin wird in zwei Teile aufgeteilt. Der erste Teil endet mit der Startzeit und der zweite Teil beginnt mit der Endzeit des neuen Sendetermins.',
      },
    },
  },

  paginator: {
    itemsPerPage: 'Einträge pro Seite',
    gotoFirst: 'Gehe zur ersten Seite',
    gotoPrev: 'Gehe zur vorherigen Seite',
    goto: 'Gehe zu Seite %{page}',
    gotoNext: 'Gehe zur nächsten Seite',
    gotoLast: 'Gehe zur letzen Seite',
    range: 'Zeige %{start} bis %{end} von %{count} Einträgen.',
  },

  schedule: {
    singular: 'Sendeschema',
    plural: 'Sendeschemata',
    fields: {
      firstDate: 'Startdatum',
      lastDate: 'Enddatum',
    },
    labels: {
      openEnded: 'Offen',
      details: 'Details',
      showActions: 'Aktionen öffnen',
      createRepetition: 'Wiederholungsschema anlegen',
      schedulesWithFailedProlongation:
        'Sendeschemata mit fehlgeschlagener automatischer Verlängerung',
      repetitionOf: 'Wiederholungsschema von',
      repetitionStartsWith: 'Startpunkt für Wiederholung',
      repetitionStartsWithFirst: 'Erster Sendetermin',
      repetitionStartsWithMostRecent: 'Zuletzt gesendeter Termin',
      repetitionStartsWithSelection: 'Auswahl',
      repetitionSchedule: 'Wiederholungsschema',
      repetitionSchedules: 'Wiederholungsschemata',
      repetitionDurationNonModifiable:
        'Die Dauer eines Wiederholungsschema richtet sich nach dem Originalschema und kann nicht geändert werden.',
      description: {
        default: '%{rrule} %{start} ‑ %{end} Uhr',
        noEndTime: `%{rrule} ab %{start}`,
      },
    },
    flows: {
      end: {
        title: 'Sendeschema beenden',
        action: 'Sendeschema nach diesem Sendetermin beenden',
        actionShort: 'Nach diesem Termin beenden',
        confirm: 'Sendeschema am %{date} beenden',
        message:
          '<p>Bist du sicher, dass du dieses Sendeschema zum %{date} beenden willst?</p><p>Nachfolgende Sendetermine werden dadurch unwiderruflich gelöscht.</p>',
      },
      delete: {
        title: 'Sendeschema löschen',
        description: 'Löscht das Sendeschema inkl. aller vergangenen und zukünftigen Sendetermine.',
        action: 'Sendeschema löschen',
        confirm: {
          text: 'Das Sendeschema wird inklusive aller vergangenen und zukünftigen Sendetermine gelöscht. Dies betrifft <strong>%{count}</strong>. Sendungsinhalte in Form von Sendungen bleiben erhalten. Diese Aktion kann nicht rückgängig gemacht werden. Bist du sicher, dass du fortfahren willst?',
          prompt: 'Bitte gib <code>%{challenge}</code> als Bestätigung ein.',
          confirmLabel: 'Sendeschema inkl. %{count} löschen',
        },
      },
      shortenOrExtend: {
        title: 'Sendeschema verlängern / kürzen',
        shorten: 'Sendeschema zum %{date} beenden',
        extend: `Sendeschema bis zum %{date} verlängern`,
        extendIndefinite: 'Sendeschema dauerhaft verlängern',
        lastBroadcast: 'Letzter Sendetermin',
        loadingLastBroadcast: 'Lade letzten Sendetermin',
        conflictResolverTitle: 'Konflikte für verlängertes Sendeschema',
      },
      prolong: {
        title: 'Manuelle Sendeschemaverlängerung',
        action: 'Problem beheben',
        prolongManually: 'Manuell verlängern',
        ignore: 'Ignorieren',
        message:
          '<p>Dieses Schema konnte nicht automatisch verlängert werden.</p><p>Du kannst das Schema manuell verlängern und eventuell auftretende Konflikte selbst beheben. Alternativ kannst du das Problem auch ignorieren. Das Schema wird dann nicht verlängert.</p>',
      },
    },
  },

  scheduleEditor: {
    titleCreate: 'Neues Sendeschema für %{show}',
    titleEdit: 'Sendeschema von "%{show}" bearbeiten',
    shortInfo: 'Über diesen Sendetermin',
    followingEpisodes: 'Nachfolgende Sendetermine',

    timeslotRuns:
      'Dieser Sendetermin läuft am <b>%{firstDate}</b> von <b>%{startTime}</b> bis <b>%{endTime}</b>',

    singleEmission: 'Dieser Sendetermin wird nur einmal ausgestrahlt.',
    coexistingTimeslot:
      'Aufgrund einer Konfliktbehebung wurden jedoch weitere Sendetermine angelegt.',

    start: 'Start',
    end: 'Ende',
    duration: 'Dauer',
    projectedEnd: 'Geplantes Ende: %{time} Uhr',

    pastEventError: 'Bitte setze ein Startdatum in der Zukunft.',
    pastEventWarning: 'Du legst einen Sendeschema an, das in der Vergangenheit beginnt.',
    from: 'Startzeit',
    to: 'Endzeit',
    fromDate: 'Startdatum',
    fromDateSingle: 'Datum',
    toDate: 'Enddatum',

    addRepetition: 'Wiederholungsprogramm hinzufügen',
    whenToRepeat: 'Wann soll wiederholt werden?',
    useSameTime: 'Selbe Start- und Endzeit verwenden',
    repeatAt: 'Wiederholen um',
    addNoOfDays: 'Wie viele Tage später?',
    onlyBusinessDays: 'Nur Werktage zählen',
    create: 'Neues Sendeschema anlegen',
    createConfirmTitle: 'Neues Sendeschema',
    createConfirmMessage: 'Soll das neue Sendeschema jetzt angelegt werden?',
    createConfirmAction: 'Ja, Sendeschema anlegen',
    noFutureEpisodes: 'Es sind keine nachfolgenden Sendetermine geplant.',
    delete: {
      schedule: 'Sendeschema inkl. aller Sendetermine löschen',
      timeslot: 'Nur diesen Sendetermin löschen',
    },
  },

  repetition: {
    nextDay: 'Am nächsten Tag',
    nextBusinessDay: 'Am nächsten Werktag',
    nDaysLater: 'Eine Anzahl von Tagen später',
  },

  editingMetadata: {
    timeSpecific: 'am %{date} Uhr',
    lastModified: 'Letzte Änderung %{time} von %{author}.',
    created: 'Angelegt %{time} von %{author}.',
  },

  calendar: {
    minutesPerRow: 'Auflösung',
    today: 'Heute',
    date: 'Datum',
    nextDay: 'Nächster Tag',
    prevDay: 'Vorheriger Tag',
    week: 'Kalenderwoche',
    currentWeek: 'Diese Woche',
    prevWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    empty: 'Keine Medien',
    fallback: 'Fallback-Medien',
    repetition: 'Wiederholung',
    showInWeekCalendar: 'Im Wochenkalender',
    view: {
      day: 'Tagesansicht',
      week: 'Wochenansicht',
    },
    switchShow: 'Zur „%{show}“ Sendereihe wechseln',
    editTimeslot: 'Sendetermin bearbeiten',
    intermission: 'Programmunterbrechung',
    mismatchedLength: 'Unpassende Länge',
    playing: 'Spielt gerade',
  },

  // Etc
  metadata: {
    artist: 'Künstler',
    album: 'Album',
    title: 'Titel',
    source: 'Quelle',
    size: 'Dateigröße',
  },

  humanJoin: {
    default: ', ',
    and: ' und ',
    or: ' oder ',
  },

  rrule: {
    rrule: 'Wiederholungsregel',
    unknown:
      'Eine automatisierte Beschreibung der Wiederholungsregel war nicht möglich. Bitte lege ein Ticket für das aura/dashboard Projekt an.',
    once: 'einmalig',
    daily: 'täglich |||| alle %{smart_count} Tage',
    weekly: 'wöchentlich |||| alle %{smart_count} Wochen',
    monthly: 'monatlich |||| alle %{smart_count} Monate',
    yearly: 'jährlich |||| alle %{smart_count} Jahre',
    businessDay: 'Werktag |||| Werktagen',
    onDays: 'am %{days}',
    position: {
      '-1': 'am letzten',
      1: 'am ersten',
      2: 'am zweiten',
      3: 'am dritten',
      4: 'am vierten',
      5: 'am fünften',
    },
  },

  steeringErrorCodes: {
    'no-start-after-end': 'Das Startdatum darf nicht hinter dem Enddatum liegen.',
    'no-same-day-start-and-end': 'Start- und Enddatum dürfen nicht auf den selben Tag fallen.',
    'one-solution-per-conflict':
      'Es wird genau eine Lösung für jeden Konflikt benötigt. Es wurde entweder keine oder zuviele Lösungen für einen Konflikt übermittelt.',
  },

  mediaResolution: {
    resolvedMedia: 'Aufgelöste Medien',
    resolvers: {
      cba: {
        validatingUrl: 'CBA: Validiere URL',
        fetchingMedia: 'CBA: Rufe Mediendaten ab',
        fetchingMetadata: 'CBA: Rufe Metadaten ab',
        processingMedia: 'CBA: Verarbeite Mediendaten',
      },
    },
  },

  i18n: {
    translatable: 'Dieses Feld kann übersetzt werden.',
    translationLanguage: 'Übersetzungssprache',
  },
}
